var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default function PostAuthCallback({ postAuthCallback, privateDispatch, user }) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const redirectTarget = yield postAuthCallback(user);
            privateDispatch({ type: 'AUTHENTICATED', user });
            window.localStorage.setItem('isLoggedIn', 'true');
            const storedRedirectTarget = window.sessionStorage.getItem('destinationAfterAuthentication');
            if (storedRedirectTarget) {
                console.log('found destinationAfterAuthentication in sessionStorage, redirecting');
            }
            privateDispatch({ type: 'BEGIN_REDIRECT', redirectTarget: storedRedirectTarget || redirectTarget });
        }
        catch (error) {
            privateDispatch({ type: 'FATAL_ERROR', reason: 'Unable to complete postAuthCallbacks', error });
            console.error('TODO review error handling here', error);
        }
    });
}
